import React from 'react';
import './BotDemo.scss'; // We can reuse the same SCSS file for consistent styling
import BotDemoLogin from './BotDemoLogin';
import BotDemo from './BotDemo';

export default function BotDemoLanding() {
  const [isLoggedIn, setIsLoggedIn] = React.useState(true);

  return (
    <>
      {isLoggedIn ? (
        // Show the BotDemo once the user logs in
        <BotDemo />
      ) : (
        // Show the login page first
        <BotDemoLogin setIsLoggedIn={setIsLoggedIn} />
      )}
    </>
  );
}
